var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{style:({'text-align': 'center'})},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v(_vm._s(_vm.$t('NotFound.message')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }